<section id="rsvp" class="rsvp menu-beige">

  <div class="rsvp-inner">

    <h2 class="rsvp-title writing-title">
      RSVP
    </h2>

    <div class="rsvp-content">

    <!-- =========================
         LEWA STRONA - FORMULARZ
         ========================= -->

    <div class="rsvp-form-card reveal reveal-from-left reveal-delay-2">

      <h3 class="rsvp-form-title">
        Potwierdź swoją obecność
      </h3>

      <form
        class="rsvp-form"
        id="rsvp-form"
      >

        <!-- ANTIBOT -->
        <div class="rsvp-honeypot" aria-hidden="true">
          <label for="website">
            Strona internetowa
          </label>

          <input
            id="website"
            name="website"
            type="text"
            tabindex="-1"
            autocomplete="off"
          >
        </div>

        <!-- =========================
             IMIĘ I NAZWISKO
             ========================= -->

        <label for="name">
          Imię i nazwisko*
        </label>

        <input
          id="name"
          name="name"
          type="text"
          autocomplete="name"
          required
        >


        <!-- =========================
             NUMER TELEFONU
             ========================= -->

        <label for="phone">
          Numer telefonu
        </label>

        <input
          id="phone"
          name="phone"
          type="tel"
          autocomplete="tel"
          placeholder="Opcjonalnie"
        >


        <!-- =========================
             OBECNOŚĆ
             ========================= -->

        <fieldset class="attendance">

          <legend>
            Potwierdzasz obecność?*
          </legend>

          <label class="attendance-option">

            <input
              type="radio"
              name="attendance"
              value="yes"
              required
            >

            <span>
              Oczywiście! Nie przegapię tego!
            </span>

          </label>


          <label class="attendance-option">

            <input
              type="radio"
              name="attendance"
              value="no"
            >

            <span>
              Niestety, nie dam rady.
            </span>

          </label>

        </fieldset>


        <!-- =========================
             POLA TYLKO DLA OBECNYCH
             ========================= -->

        <div
          id="rsvp-extra-fields"
          class="rsvp-extra-fields hidden"
        >

          <!-- =========================
              LICZBA OSÓB
              ========================= -->

          <label for="guest-count">
            Ile osób obejmuje Wasze potwierdzenie?*
          </label>

          <select
            id="guest-count"
            name="guestCount"
            required
          >
            <option value="">
              Wybierz liczbę osób
            </option>

            <option value="1">1 osoba</option>
            <option value="2">2 osoby</option>
            <option value="3">3 osoby</option>
            <option value="4">4 osoby</option>
            <option value="5">5 osób</option>
            <option value="6">6 osób</option>
          </select>


          <!-- =========================
              DODATKOWE OSOBY
              ========================= -->

          <div
            id="additional-guests"
            class="rsvp-guest-fields"
          >

            <div
              class="additional-guest hidden"
              data-guest="2"
            >
              <label for="guest-2">
                Imię i nazwisko osoby 2*
              </label>

              <input
                id="guest-2"
                name="guest2"
                type="text"
                autocomplete="off"
              >
            </div>


            <div
              class="additional-guest hidden"
              data-guest="3"
            >
              <label for="guest-3">
                Imię i nazwisko osoby 3*
              </label>

              <input
                id="guest-3"
                name="guest3"
                type="text"
                autocomplete="off"
              >
            </div>


            <div
              class="additional-guest hidden"
              data-guest="4"
            >
              <label for="guest-4">
                Imię i nazwisko osoby 4*
              </label>

              <input
                id="guest-4"
                name="guest4"
                type="text"
                autocomplete="off"
              >
            </div>


            <div
              class="additional-guest hidden"
              data-guest="5"
            >
              <label for="guest-5">
                Imię i nazwisko osoby 5*
              </label>

              <input
                id="guest-5"
                name="guest5"
                type="text"
                autocomplete="off"
              >
            </div>


            <div
              class="additional-guest hidden"
              data-guest="6"
            >
              <label for="guest-6">
                Imię i nazwisko osoby 6*
              </label>

              <input
                id="guest-6"
                name="guest6"
                type="text"
                autocomplete="off"
              >
            </div>

          </div>


          <!-- =========================
               DIETA
               ========================= -->

          <label for="food">
            Czy ktoś z Was ma alergie pokarmowe
             lub szczególne preferencje dotyczące jedzenia?
          </label>

          <textarea
            id="food"
            name="food"
            rows="3"
            placeholder="Np. dieta wegetariańska, bez glutenu, alergia na orzechy..."
          ></textarea>


          <!-- =========================
               UWAGI
               ========================= -->

          <label for="notes">
            Dodatkowe uwagi
          </label>

          <textarea
            id="notes"
            name="notes"
            rows="3"
          ></textarea>

        </div>


        <!-- =========================
             PRZYCISK
             ========================= -->

        <button
          type="submit"
          class="rsvp-submit"
          id="rsvp-submit"
        >
          Wyślij potwierdzenie
        </button>


        <!-- =========================
             KOMUNIKAT
             ========================= -->

        <div
          id="rsvp-message"
          class="rsvp-message"
          aria-live="polite"
        ></div>

      </form>

    </div>


    <!-- =========================
         PRAWA STRONA
         ========================= -->

    <div class="rsvp-info reveal reveal-from-right reveal-delay-1">

      <div class="rsvp-deadline">
        Prosimy, potwierdź swoją obecność<br>
        do dnia <strong>10.06.2027</strong>
      </div>


      <div class="rsvp-contact-text">
        Swoją obecność możesz potwierdzić wypełniając formularz
        bądź kontaktując się z nami bezpośrednio pod podanymi
        numerami telefonów:
      </div>


      <div class="rsvp-contacts">

        <div class="rsvp-contact">
          <span>MAJA PIETROWSKA</span>
          <span>533-581-515</span>
        </div>

        <div class="rsvp-contact">
          <span>MACIEJ SIWEK</span>
          <span>793-496-031</span>
        </div>

      </div>

    </div>

  </div>

  </div>

</section>


<style>

  /* =========================
     CAŁA SEKCJA
     ========================= */

  .rsvp {
    min-height: 100vh;

    box-sizing: border-box;

    background-color: #e6e4dd;

    padding: 7em 8vw 6em;
  }


  /* =========================
     TYTUŁ
     ========================= */

  .rsvp-inner {
    width: 100%;
    max-width: 1300px;

    margin: 0 auto;
  }


  .rsvp-title {
    width: 100%;

    margin:
      0
      0
      0.7em;

    box-sizing: border-box;

    font-family: "WindSong", cursive;

    font-size: 5.5em;
    font-weight: 400;

    text-align: left;

    transform: rotate(-4deg);
    transform-origin: left center;
  }


  /* =========================
     UKŁAD
     ========================= */

  .rsvp-content {
    width: 100%;

    display: grid;
    grid-template-columns: 0.85fr 1.15fr;

    gap: 7em;

    align-items: center;
  }


  /* =========================
     FORMULARZ
     ========================= */

  .rsvp-form-card {
    width: 100%;
    max-width: 460px;

    box-sizing: border-box;

    padding: 2.8em;

    background-color: #ffffff;

    border: 4px solid #f4ecd5;
    border-radius: 16px;
  }


  .rsvp-form-title {
    margin: 0 0 1.8em;

    font-family: "Cinzel", serif;

    font-size: 1.4em;
    font-weight: 600;

    letter-spacing: 0.08em;
  }


  .rsvp-form {
    display: flex;
    flex-direction: column;

    gap: 1.2em;
  }

  /* =========================
   ANTIBOT
   ========================= */

  .rsvp-honeypot {
    position: absolute !important;

    left: -9999px !important;

    width: 1px !important;
    height: 1px !important;

    overflow: hidden !important;

    opacity: 0 !important;

    pointer-events: none !important;
  }


  .rsvp-form label,
  .attendance legend {
    font-family: "Cormorant Garamond", serif;

    font-size: 1.05em;
  }


  .rsvp-form input[type="text"],
  .rsvp-form input[type="tel"],
  .rsvp-form select,
  .rsvp-form textarea {
    width: 100%;

    box-sizing: border-box;

    padding: 0.8em;

    border: 1px solid #bdb8ad;
    border-radius: 5px;

    background-color: #ffffff;

    font-family: "Cormorant Garamond", serif;

    font-size: 1em;
  }


  .rsvp-form input[type="text"]:focus,
  .rsvp-form input[type="tel"]:focus,
  .rsvp-form select:focus,
  .rsvp-form textarea:focus {
    outline: none;

    border-color: #9f9682;
  }


  .rsvp-form textarea {
    resize: vertical;
  }

  .additional-guest {
    display: flex;
    flex-direction: column;
    gap: 0.6em;
  }

  .additional-guest.hidden {
    display: none;
  }


  /* =========================
     RADIO
     ========================= */

  .attendance {
    display: flex;
    flex-direction: column;

    gap: 0.6em;

    margin: 0;
    padding: 0;

    border: 0;
  }


  .attendance legend {
    margin-bottom: 0.7em;
  }


  .attendance-option {
    display: flex;
    align-items: center;

    gap: 0.8em;

    padding: 0.9em 1em;

    background-color: #eeeeee;

    border-radius: 6px;

    cursor: pointer;
  }


  .attendance-option input {
    margin: 0;
  }


  /* =========================
     WARUNKOWE POLA
     ========================= */

  .rsvp-extra-fields {
    display: flex;
    flex-direction: column;

    gap: 1.2em;
  }


  .rsvp-guest-fields {
    display: flex;
    flex-direction: column;

    gap: 1.2em;
  }


  .rsvp-extra-fields.hidden,
  .rsvp-guest-fields.hidden {
    display: none;
  }


  /* =========================
     BUTTON
     ========================= */

  .rsvp-submit {
    margin-top: 0.5em;

    padding: 0.9em 1.5em;

    border: 0;
    border-radius: 18px;

    background-color: #d8cfb3;

    color: black;

    font-family: "Cormorant Garamond", serif;

    font-size: 1.1em;
    font-weight: 600;

    cursor: pointer;

    transition:
      transform 0.2s ease,
      background-color 0.2s ease,
      opacity 0.2s ease;
  }


  .rsvp-submit:hover {
    transform: translateY(-2px);

    background-color: #cfc4a4;
  }


  .rsvp-submit:disabled {
    opacity: 0.6;

    cursor: wait;

    transform: none;
  }


  /* =========================
     KOMUNIKAT PO WYSŁANIU
     ========================= */

  .rsvp-message {
    min-height: 1.5em;

    margin: 0.3em 0 0;

    font-family: "Cormorant Garamond", serif;

    line-height: 1.4;

    text-align: center;
  }


  .rsvp-message.success {
    padding: 1.2em;

    background-color: #f7f3e8;

    border-radius: 10px;
  }


  .rsvp-message.error {
    color: #8a4545;

    font-size: 1.05em;
    font-weight: 600;
  }


  .rsvp-message-title {
    margin-bottom: 0.35em;

    font-size: 1.3em;
    font-weight: 600;
  }


  .rsvp-message-text {
    font-size: 1.05em;
  }


  /* =========================
     PRAWA STRONA
     ========================= */

  .rsvp-info {
    display: flex;
    flex-direction: column;

    gap: 3em;
  }


  .rsvp-deadline {
    font-family: "Cormorant Garamond", serif;

    font-size: 2em;

    line-height: 1.2;
  }


  .rsvp-contact-text {
    max-width: 650px;

    font-family: "Cormorant Garamond", serif;

    font-size: 1.3em;

    line-height: 1.5;
  }


  /* =========================
     KONTAKTY
     ========================= */

  .rsvp-contacts {
    display: flex;
    flex-direction: column;

    gap: 1.8em;
  }


  .rsvp-contact {
    display: grid;

    grid-template-columns: 180px 1fr;

    gap: 1em;

    font-family: "Cormorant Garamond", serif;

    font-size: 1.3em;
  }


  /* =========================
     TABLET
     ========================= */

  @media (max-width: 900px) {

    .rsvp-content {
      grid-template-columns: minmax(0, 1fr);

      gap: 3em;
    }


    .rsvp-title {
      text-align: center;

      font-size: 4.5em;

      transform-origin: center;
    }


    .rsvp-info {
      order: 1;

      width: 100%;

      text-align: center;
      align-items: center;
    }


    .rsvp-form-card {
      order: 2;

      width: min(100%, 460px);

      margin: 0 auto;
    }

  }


  /* =========================
     TELEFON
     ========================= */

  @media (max-width: 600px) {

    .rsvp {
      width: 100%;

      padding: 5em 1rem 3.5em;

      box-sizing: border-box;

      overflow-x: hidden;
    }


    .rsvp-title {
      font-size: 3.8em;

      margin-bottom: 0.4em;

      text-align: center;

      transform: rotate(-3deg);
      transform-origin: center;
    }


    .rsvp-content {
      width: 100%;

      gap: 2.5em;
    }


    /* INFORMACJE NA GÓRZE */

    .rsvp-info {
      order: 1;

      width: 100%;

      gap: 1.8em;

      text-align: center;
      align-items: center;
    }


    .rsvp-deadline {
      font-size: 1.6em;

      line-height: 1.3;
    }


    .rsvp-contact-text {
      width: 100%;
      max-width: 100%;

      font-size: 1.15em;

      line-height: 1.45;
    }


    .rsvp-contacts {
      width: 100%;

      gap: 1.4em;
    }


    .rsvp-contact {
      grid-template-columns: 1fr;

      gap: 0.2em;

      text-align: center;

      font-size: 1.2em;
    }


    /* FORMULARZ */

    .rsvp-form-card {
      order: 2;

      width: 100%;
      max-width: 460px;

      margin: 0 auto;

      padding: 2em 1.25em;

      box-sizing: border-box;
    }


    .rsvp-form-title {
      font-size: 1.2em;

      text-align: center;
    }


    .rsvp-form {
      width: 100%;
    }


    .attendance-option {
      width: 100%;

      box-sizing: border-box;
    }


    .rsvp-submit {
      width: 100%;

      box-sizing: border-box;
    }


    .rsvp-message.success {
      padding: 1em;
    }

  }

</style>


<script>

  /* =========================
     GOOGLE APPS SCRIPT
     ========================= */

  const RSVP_URL =
    "https://script.google.com/macros/s/AKfycbxE--OtaKoJ6I250jCuoC_xA-OojKbPd18AFCFfdMZtKTPstt2OpBF7aypyPSAH7FHjAQ/exec";


  /* =========================
     ELEMENTY FORMULARZA
     ========================= */

  const form =
    document.getElementById("rsvp-form");

  const submitButton =
    document.getElementById("rsvp-submit");

  const message =
    document.getElementById("rsvp-message");

  const attendanceInputs =
    document.querySelectorAll(
      'input[name="attendance"]'
    );

  const extraFields =
    document.getElementById("rsvp-extra-fields");

  const guestCountSelect =
    document.getElementById("guest-count");

  const additionalGuests =
    document.querySelectorAll(".additional-guest");

  const foodInput =
    document.getElementById("food");

  const notesInput =
    document.getElementById("notes");


  /* =========================
     FUNKCJA CZYSZCZĄCA
     DODATKOWE OSOBY
     ========================= */

  function resetAdditionalGuests() {

    additionalGuests.forEach((guestField) => {

      if (!(guestField instanceof HTMLElement)) {
        return;
      }

      guestField.classList.add("hidden");

      const input =
        guestField.querySelector("input");

      if (input instanceof HTMLInputElement) {

        input.value = "";
        input.required = false;

      }

    });

  }


  /* =========================
     CZY GOŚĆ PRZYCHODZI?
     ========================= */

  attendanceInputs.forEach((input) => {

    if (!(input instanceof HTMLInputElement)) {
      return;
    }

    input.addEventListener("change", () => {

      if (!(extraFields instanceof HTMLElement)) {
        return;
      }


      /* =========================
         TAK
         ========================= */

      if (input.value === "yes") {

        extraFields.classList.remove("hidden");

      }


      /* =========================
         NIE
         ========================= */

      if (input.value === "no") {

        extraFields.classList.add("hidden");


        /* Czyścimy liczbę osób */

        if (
          guestCountSelect instanceof
          HTMLSelectElement
        ) {

          guestCountSelect.value = "";

        }


        /* Czyścimy dodatkowe osoby */

        resetAdditionalGuests();


        /* Czyścimy dietę */

        if (
          foodInput instanceof HTMLSelectElement ||
          foodInput instanceof HTMLInputElement ||
          foodInput instanceof HTMLTextAreaElement
        ) {

          foodInput.value = "";

        }


        /* Czyścimy uwagi */

        if (
          notesInput instanceof HTMLTextAreaElement ||
          notesInput instanceof HTMLInputElement
        ) {

          notesInput.value = "";

        }

      }

    });

  });


  /* =========================
     LICZBA OSÓB
     ========================= */

  if (
    guestCountSelect instanceof
    HTMLSelectElement
  ) {

    guestCountSelect.addEventListener(
      "change",
      () => {

        const selectedCount =
          Number(guestCountSelect.value);


        additionalGuests.forEach(
          (guestField) => {

            if (
              !(guestField instanceof HTMLElement)
            ) {
              return;
            }

            const guestNumber =
              Number(guestField.dataset.guest);

            const input =
              guestField.querySelector("input");

            if (
              !(input instanceof HTMLInputElement)
            ) {
              return;
            }


            /* =========================
               POKAZUJEMY OSOBĘ
               ========================= */

            if (
              selectedCount >= guestNumber
            ) {

              guestField.classList.remove(
                "hidden"
              );

              input.required = true;

            }


            /* =========================
               CHOWAMY OSOBĘ
               ========================= */

            else {

              guestField.classList.add(
                "hidden"
              );

              input.required = false;
              input.value = "";

            }

          }
        );

      }
    );

  }


  /* =========================
     WYSYŁANIE FORMULARZA
     ========================= */

  if (
    form instanceof HTMLFormElement &&
    submitButton instanceof HTMLButtonElement &&
    message instanceof HTMLElement
  ) {

    form.addEventListener(
      "submit",
      async (event) => {

        event.preventDefault();


        /* =========================
           START WYSYŁANIA
           ========================= */

        submitButton.disabled = true;

        submitButton.textContent =
          "Wysyłanie...";

        message.textContent = "";

        message.className =
          "rsvp-message";


        try {

          /* =========================
             POBIERAMY DANE
             ========================= */

          const formData =
            new FormData(form);


          /* =========================
             ANTIBOT
             ========================= */

          const honeypot =
            formData.get("website");

          if (honeypot) {
            return;
          }


          /*
            Zapisujemy imię i obecność
            PRZED form.reset().
          */

          const guestNameValue =
            formData.get("name");

          const guestName =
            typeof guestNameValue === "string"
              ? guestNameValue
              : "";

          const attendance =
            formData.get("attendance");


          /* =========================
             WYSYŁAMY DO GOOGLE
             ========================= */

          const response =
            await fetch(
              RSVP_URL,
              {
                method: "POST",
                body: formData
              }
            );

          if (!response.ok) {

            throw new Error(
              "Nie udało się zapisać RSVP."
            );

          }


          /* =========================
             KOMUNIKAT
             ========================= */

          const messageTitle =
            document.createElement("div");

          messageTitle.className =
            "rsvp-message-title";

          messageTitle.textContent =
            `Dziękujemy, ${guestName}! ♡`;


          const messageText =
            document.createElement("div");

          messageText.className =
            "rsvp-message-text";


          /* =========================
             KOMUNIKAT - TAK
             ========================= */

          if (attendance === "yes") {

            messageText.textContent =
              "Twoja odpowiedź została zapisana. Nie możemy się doczekać, aż się zobaczymy!";

          }


          /* =========================
             KOMUNIKAT - NIE
             ========================= */

          else {

            messageText.textContent =
              "Twoja odpowiedź została zapisana. Szkoda, że nie będziesz z nami tego dnia — mamy nadzieję, że niedługo się zobaczymy!";

          }


          message.replaceChildren(
            messageTitle,
            messageText
          );

          message.className =
            "rsvp-message success";


          /* =========================
             CZYŚCIMY FORMULARZ
             ========================= */

          form.reset();

          if (
            extraFields instanceof HTMLElement
          ) {

            extraFields.classList.add(
              "hidden"
            );

          }

          resetAdditionalGuests();

        }


        /* =========================
           BŁĄD
           ========================= */

        catch (error) {

          console.error(
            "Błąd RSVP:",
            error
          );

          message.textContent =
            "Nie udało się wysłać odpowiedzi. Spróbuj ponownie lub skontaktuj się z nami telefonicznie.";

          message.className =
            "rsvp-message error";

        }


        /* =========================
           KONIEC
           ========================= */

        finally {

          submitButton.disabled = false;

          submitButton.textContent =
            "Wyślij potwierdzenie";

        }

      }
    );

  }

</script>